export default __webpack_public_path__ + "static/img-ef-10-d58ddd883e2112058ea7820160e078ec.png";